import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FormatColorFillIcon from "@mui/icons-material/FormatColorFill";
import FontDownloadIcon from "@mui/icons-material/FontDownload";
import FlagIcon from "@mui/icons-material/Flag";
import SettingsIcon from "@mui/icons-material/Settings";
import SubSidebar from "./SubSidebar/SubSidebar";
import React from "react";

export type SidebarMenus =
  | "pages"
  | "templates"
  | "color"
  | "font"
  | "flag"
  | "settings"
  | "";

interface SidebarProps {
  selectedMenu: SidebarMenus;
  setSelectedMenu: React.Dispatch<React.SetStateAction<SidebarMenus>>;
  editPageId: number | null;
  setEditPageId: React.Dispatch<React.SetStateAction<number | null>>;
}

export default function Sidebar({
  selectedMenu,
  setSelectedMenu,
  editPageId,
  setEditPageId,
}: SidebarProps) {
  function toggleActive(name: SidebarMenus) {
    setSelectedMenu(name == selectedMenu ? "" : name);
  }

  return (
    <>
      <div
        className="sidebar d-flex flex-column align-items-center"
        style={{ zIndex: 1 }}
      >
        <ul className="b-ps-0">
          <li
            onClick={() => toggleActive("pages")}
            className={selectedMenu == "pages" ? "active" : ""}
          >
            <FormatListBulletedIcon />
          </li>
          <li
            id="toggleTemplatesMenu"
            onClick={() => toggleActive("templates")}
            className={selectedMenu == "templates" ? "active" : ""}
          >
            <DashboardIcon />
          </li>
          <li
            onClick={() => toggleActive("color")}
            className={selectedMenu == "color" ? "active" : ""}
          >
            <FormatColorFillIcon />
          </li>
          <li
            onClick={() => toggleActive("font")}
            className={selectedMenu == "font" ? "active" : ""}
          >
            <FontDownloadIcon />
          </li>
          <li
            onClick={() => toggleActive("flag")}
            className={selectedMenu == "flag" ? "active" : ""}
          >
            <FlagIcon />
          </li>
          <li
            onClick={() => toggleActive("settings")}
            className={selectedMenu == "settings" ? "active" : ""}
          >
            <SettingsIcon />
          </li>
        </ul>
      </div>
      <SubSidebar
        selectedMenu={selectedMenu}
        setSelectedMenu={setSelectedMenu}
        editPageId={editPageId}
        setEditPageId={setEditPageId}
      />
    </>
  );
}
